export {Highlight, Highlight as default, Type} from './highlight.component';
export {getIndexesOfMatches} from './utils';

export type {MatchedChunks, IndexesOfMatches} from './highlight.component';
